import Hls from "hls.js";
import logger from '../../../utils/logger';

export function createHlsAdapter(src) {
  let hls = null;
  let videoEl = null;
  
  return {
    name: "hls",
    async attach(video) {
      videoEl = video;
      if (video.canPlayType("application/vnd.apple.mpegurl")) {
        video.src = src.playlistUrl;
        return new Promise((resolve, reject) => {
          video.addEventListener('loadeddata', () => resolve(), { once: true });
          video.addEventListener('error', reject, { once: true });
          video.play().catch(() => undefined);
        });
      }
      if (Hls.isSupported()) {
        hls = new Hls({ enableWorker: true });
        return new Promise((resolve, reject) => {
          video.addEventListener('loadeddata', () => resolve(), { once: true });
          video.addEventListener('error', reject, { once: true });
          hls.on(Hls.Events.MANIFEST_PARSED, () => {
            video.play().catch(() => undefined);
          });
          hls.on(Hls.Events.ERROR, (event, data) => {
            console.error('HLS Error Details:', data);
            if (data.fatal) reject(new Error(`HLS Error: ${data.details} (${data.type})`));
          });
          hls.loadSource(src.playlistUrl);
          hls.attachMedia(video);
        });
      }
      throw Object.assign(new Error("HLS not supported by this browser"), { code: "HLS_UNSUPPORTED" });
    },
    async detach() {
      if (hls) {
        hls.destroy();
        hls = null;
      }
      if (videoEl) {
        // Stop any tracks from the video element's stream
        if (videoEl.srcObject) {
          const stream = videoEl.srcObject;
          if (stream instanceof MediaStream) {
            stream.getTracks().forEach((track) => {
              track.stop();
            });
          }
        }
        
        // Revoke blob URL if src is a blob URL
        if (videoEl.src && videoEl.src.startsWith('blob:')) {
          URL.revokeObjectURL(videoEl.src);
        }
        
        videoEl.removeAttribute("src");
        videoEl.srcObject = null;
        videoEl.load();
        videoEl = null;
      }
    },
    async play() {
      await videoEl?.play();
    },
    async pause() {
      videoEl?.pause();
    }
  };
}
